(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/views/winmaps.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/views/winmaps.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.views.WinMaps = Marionette.View.extend({
    className: 'bg-lotto padding-top-1-half f-center winmaps-container',
    regions: {
      mapRegion: '#mapRegion',
      listRegion: '#listRegion'
    },
    events: {
      'click .js-change-view': 'navigateView'
    },
    activeView: 'map',
    mapAspectRatio: 2.315,
    mapHeightScale: 0.75,
    template(data) {
      return svs.map_of_winners.templates.winmaps(data);
    },
    templateContext() {
      let title, subtitle;
      if (svs.map_of_winners.data.mapTitles) {
        var _svs$map_of_winners$d = svs.map_of_winners.data.mapTitles;
        title = _svs$map_of_winners$d.title;
        subtitle = _svs$map_of_winners$d.subtitle;
      }
      return {
        isXXSScreen: screen.width < 350,
        title,
        subtitle
      };
    },
    initialize() {
      const mapHeight = window.innerHeight * this.mapHeightScale,
        mapWidth = mapHeight / this.mapAspectRatio;
      this.model = new svs.map_of_winners.models.BigWinInfo(svs.map_of_winners.data.bigWinInfo.bigWinAttributes, {
        bigwinnerList: svs.map_of_winners.data.bigWinInfo.bigwinnerList,
        mapHeight,
        mapWidth
      });
    },
    onRender() {
      this.getRegion('listRegion').show(new svs.map_of_winners.views.Lists({
        collection: this.model.get('bigwinnerList')
      }));
      this.getRegion('mapRegion').show(new svs.map_of_winners.views.map({
        model: this.model,
        collection: this.model.get('bigwinnerList'),
        aspectRatio: this.mapAspectRatio,
        mapHeightScale: this.mapHeightScale
      }));
    },
    navigateView(e) {
      if (e.currentTarget.value !== this.activeView) {
        this.activeView = e.currentTarget.value;
        this.getRegion('mapRegion').currentView.$el.toggle();
        this.getRegion('listRegion').currentView.$el.toggle();
      }
    }
  });
})(Backbone, _, svs);

 })(window);